<template>
    <nav id="nav" class="sm:container sm:mx-auto">
        <!-- Header start -->
        <div
            class="z-10 max-w-screen-lg xl:max-w-screen-xl block sm:flex sm:justify-between sm:items-center my-3 md:my-0"
        >
            <!-- Header menu links and small screen hamburger menu -->
            <div class="flex justify-between items-center px-4 sm:px-0">
                <!-- Header logos -->
                <div class="flex">
                    <router-link to="/"
                        >
                        <img
                            src="@/assets/images/logo.png"
                            class="logo"
                            alt="Delfinariu Constanta Logo"
                        />
                    </router-link>
					<router-link to="/checkout" v-if="expTime != null" class="margin-auto">
						<div class="timer-style timer-container ml-10">
							<i data-feather="clock" class="mr-1"></i>
							<Timer :expTime="expTime" class="pr-2" />
						</div>
					</router-link>
                </div>

                <!-- Small screen hamburger menu -->
                <div class="sm:hidden">
                    <button
                        @click="isOpen = !isOpen"
                        type="button"
                        class="focus:outline-none"
                        aria-label="Hamburger Menu"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            class="h-7 w-7 fill-current text-secondary-dark dark:text-ternary-light"
                        >
                            <path
                                v-if="isOpen"
                                fill-rule="evenodd"
                                d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"
                                clip-rule="evenodd"
                            ></path>
                            <path
                                v-if="!isOpen"
                                fill-rule="evenodd"
                                d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2z"
                            ></path>
                        </svg>
                    </button>
                </div>
            </div>

            <!-- Header links -->
            <AppHeaderLinks :isOpen="isOpen" />

            <!-- Header right section buttons -->
            <div
                class="hidden sm:flex justify-between items-center flex-col md:flex-row"
            >
            <LanguageSwitcher/>
            </div>
        </div>
    </nav>
</template>

<script>
// import ThemeSwitcher from '../ThemeSwitcher';
import { mapGetters } from "vuex";
import feather from 'feather-icons';
import AppHeaderLinks from './AppHeaderLinks.vue';
// import Button from '../reusable/Button.vue';
import LanguageSwitcher from './LanguageSwitcher.vue';
import Timer from './Timer.vue';

export default {
    components: {
        Timer,
        AppHeaderLinks,
        LanguageSwitcher
        // Button,
    },
    data() {
        return {
            isOpen: false,
            expTime: null, // Local state to hold the expTime value
        };
    },
    created() {
        this.expTime = this.getCartExpTime; // Initialize expTime with the current value
    },
    mounted() {
        feather.replace();
    },
    computed: {
        ...mapGetters(['getCart', 'getCartExpTime']),
        getExpTime() {
            return this.getCartExpTime; // Create a computed property for getCart.cart
        }
    },
    watch: {
        getExpTime: {
            handler(newValue) {
                this.expTime = newValue;
            },
            immediate: true // Ensure the watcher runs immediately on component load
        }
    },
    updated() {
        feather.replace();
    },
};
</script>

<style scoped>
#nav a.router-link-exact-active {
    @apply text-indigo-700;
    @apply dark:text-indigo-400;
    @apply font-medium;
}

.timer-container {
  display: flex;
  align-items: center;
  padding: 0.2rem 0.2rem;
  font-weight: bold;
  z-index: 10; /* Ensure it appears above other elements */
  color: black;
}

.timer-container i {
  color: #4b5563; /* Gray color for the icon */
  height: 12px;
}

.margin-auto {
  margin-top: auto;
  margin-bottom: auto;
}
</style>
